import type { UsageRange, UsageSeriesPoint } from "./usage.types";

// The parts of the token total, rendered as the stacked series. lawlineTokens is a billing
// currency in a different unit, so it shows as a KPI and never stacks with these.
export type TokenSeriesKey = Extract<
	keyof UsageSeriesPoint,
	"input" | "output" | "cacheRead" | "cacheWrite" | "reasoning"
>;

export interface TokenSeries {
	// Stable id; label resolved at render via t(`series.${key}`).
	key: TokenSeriesKey;
	color: string;
}

// Fixed Tailwind palette (500 shades) rather than the @lawline/ui --chart-* vars.
export const TOKEN_SERIES: readonly TokenSeries[] = [
	{ key: "input", color: "#10b981" }, // emerald-500
	{ key: "output", color: "#3b82f6" }, // blue-500
	{ key: "cacheRead", color: "#8b5cf6" }, // violet-500
	{ key: "cacheWrite", color: "#f59e0b" }, // amber-500
	{ key: "reasoning", color: "#f43f5e" }, // rose-500
];

// Stable range ids paired with their "usage.ranges" translation key. "billing"
// (current Stripe billing period) is the default, so it leads.
export const RANGE_OPTIONS: readonly {
	value: UsageRange;
	labelKey: "billingPeriod" | "sevenDays" | "thirtyDays" | "ninetyDays";
}[] = [
	{ value: "billing", labelKey: "billingPeriod" },
	{ value: "7d", labelKey: "sevenDays" },
	{ value: "30d", labelKey: "thirtyDays" },
	{ value: "90d", labelKey: "ninetyDays" },
];
